/**
 * Simple Alpine.js Upsell Component
 * Just adds product to cart when button is clicked
 */

document.addEventListener("alpine:init", () => {
  Alpine.data("upsellSimple", (formId) => ({
    isLoading: false,

    async addToCart() {
      // Prevent double execution
      if (this.isLoading) {
        return;
      }

      const form = document.getElementById(formId);
      if (!form) {
        console.error("Form not found:", formId);
        return;
      }

      const variantId = form.querySelector('input[name="id"]')?.value;
      if (!variantId) {
        console.error("No variant ID found");
        return;
      }

      this.isLoading = true;

      try {
        const response = await fetch(window.routes.cart_add_url + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });

        if (!response.ok) throw new Error("Failed to add to cart");

        // Show success immediately
        this.isLoading = false;
        const button = form.querySelector('button[name="upsell-add"]');
        if (button) {
          const originalText = button.innerHTML;
          button.innerHTML = "Added!";
          button.style.backgroundColor = "#4CAF50";
          setTimeout(() => {
            button.innerHTML = originalText;
            button.style.backgroundColor = "";
          }, 1500);
        }

        // Try to refresh cart count (with error handling)
        try {
          const cart = await fetch("/cart.js").then((r) => r.json());
          document
            .querySelectorAll(".cart-count-bubble, [data-cart-count]")
            .forEach((el) => (el.textContent = cart.item_count));
        } catch (countError) {
          // Cart count update failed, but product was added successfully
        }

        // Fast cart drawer refresh
        try {
          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer) {
            // Method 1: Try to trigger a cart refresh event (instant)
            document.dispatchEvent(new CustomEvent("cart:refresh"));

            // Method 2: Immediate fallback - reload cart drawer section
            const response = await fetch(`${window.routes.cart_url}?section_id=cart-drawer`);
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const newCartDrawer = doc.querySelector("cart-drawer");

            if (newCartDrawer && cartDrawer) {
              cartDrawer.innerHTML = newCartDrawer.innerHTML;
            }
          }
        } catch (drawerError) {
          // Cart drawer refresh failed, but product was added successfully
        }
      } catch (error) {
        console.error("Error adding to cart:", error);
        this.isLoading = false;
        alert("Erreur lors de l'ajout au panier");
      }
    },

    handleVariantChange() {
      const form = document.getElementById(formId);
      if (!form) return;

      const selects = form.querySelectorAll('select[name^="options["]');
      const productJsonEl = form.querySelector("#upsell-product-json");

      if (!productJsonEl) return;

      try {
        const product = JSON.parse(productJsonEl.textContent);
        const selectedOptions = Array.from(selects).map((s) => s.value);
        const variant = product.variants.find((v) => selectedOptions.every((opt, i) => v.options[i] === opt));

        if (variant) {
          form.querySelector('input[name="id"]').value = variant.id;
        }
      } catch (error) {
        console.error("Error handling variant change:", error);
      }
    },
  }));
});
